<anb-modal #exceptionDialogModal id="exceptionDialogModal" [title]="title" [closeOnBackdrop]="false">
  <p>
    {{ message }}
  </p>

  <div class="vl-action-group vl-action-group--align-right mt-10">
    <button class="vl-button" type="submit" (click)="close()">Ok</button>
  </div>
</anb-modal>
